import Pricing from '../../app/pricing/home'

export default Pricing
